import { createStore } from 'vuex';

// Create a new store instance.
export default createStore({
  state() {
    return {
      notifications: {},
    };
  },
  mutations: {
    PUSH_NOTIFICATION_STATE: (state, params) => {
      state.notifications = (params);
    },
  },
  actions: {
    HANDLE_NOTIFICATION_STATE: ({ commit }, params) => {
      commit('PUSH_NOTIFICATION_STATE', params);
    },
  },
  getters: {
    notifications: (state) => state.notifications,
  },
});
